import { media } from "@literati/public-ui-shared-react";
import { css } from "styled-components";
import { deckCardHeight } from "components/bookShuffle/bookShuffleStyles";
import { dialogCardHeight } from "components/bookShuffle/bookShuffleStyles";

const pagePaddingY = {
  DEFAULT: "5dvh",
  MD: "5dvh",
  LG: "10dvh",
} as const;

export const onboardingBookShufflePageCardPadding = css`
  padding: ${pagePaddingY.DEFAULT} 0;

  @media only screen and (min-height: 750px) {
    padding: ${pagePaddingY.LG} 0;
  }
`;

/**
 * Styled-components seems to do some pre-processing on these styles,
 * making nested `calc` expressions necessary for them not to get deleted.
 */
export const onboardingBookShuffleDialogPadding = css`
  padding: calc(
      ${pagePaddingY.DEFAULT} +
        calc(calc(${deckCardHeight.DEFAULT} - ${dialogCardHeight}) / 2)
    )
    0 0;

  ${media.md} {
    padding: calc(
        ${pagePaddingY.MD} +
          calc(calc(${deckCardHeight.DEFAULT} - ${dialogCardHeight}) / 2)
      )
      0 0;
  }

  ${media.lg} {
    padding: calc(
        ${pagePaddingY.LG} +
          calc(calc(${deckCardHeight.LG} - ${dialogCardHeight}) / 2)
      )
      0 0;
  }
`;
